import { CreateQuestionInput } from '__generatedTypes__/globalTypes'
import { findOneQuestion_findOneQuestion as Question } from '__generatedTypes__/findOneQuestion'
import { FormState, TableField } from '../../consts'

export const EMPTY_TABLE_API_VALUES: Pick<
  CreateQuestionInput,
  'endodonticTable' | 'orthodonticTable' | 'periodontalTable'
> = {
  endodonticTable: null,
  orthodonticTable: null,
  periodontalTable: null,
}

export const getInitialTableFields = (
  tableFields: TableField[],
  questionData?: Partial<Question> | null
): Partial<FormState> =>
  tableFields.reduce<Partial<FormState>>((acc, table) => {
    const formValue = table.initialize(questionData?.[table.apiKey])

    return {
      ...acc,
      [table.formKey]: formValue,
      [table.isNeedKey]: !!formValue,
    }
  }, {})

export const getTableFieldsForSubmit = (
  tableFields: TableField[],
  values: Partial<FormState>
): Pick<CreateQuestionInput, 'endodonticTable' | 'orthodonticTable' | 'periodontalTable'> => {
  const tables = { ...EMPTY_TABLE_API_VALUES }

  tableFields.forEach((table) => {
    tables[table.apiKey] = values[table.isNeedKey] ? table.prepare(values[table.formKey]) : null
  })

  return tables
}
